<template>
    <v-content>
        <v-container class="fill-height" fluid>
            <v-row align="center" justify="center">
                <v-col cols="12" sm="8" md="4">
                    <v-form @submit="login">
                        <v-card class="elevation-12">
                            <v-toolbar color="primary" dark flat>
                                <v-toolbar-title>OrderDash login</v-toolbar-title>
                            </v-toolbar>
                            <v-card-text>
                                <v-form>
                                    <v-text-field @keyup.enter="login" v-model="credentials.username" id="username" label="Brukernavn" name="username" prepend-icon="person" type="text" ref="username"/>
                                    <v-text-field @keyup.enter="login" v-model="credentials.password" id="password" label="Passord" name="password" prepend-icon="lock" type="password"/>
                                </v-form>
                            </v-card-text>
                            <v-card-actions>
                                <v-spacer/>
                                <v-btn color="primary" type="submit">Login</v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-form>
                </v-col>
            </v-row>
        </v-container>
    </v-content>

</template>

<script>
    export default {
        data() {
            return {
                credentials: {
                    username: '',
                    password: ''
                }
            }
        },
        methods: {
            login() {
                const credentials = {
                    username: this.credentials.username,
                    password: this.credentials.password
                };
                this.$store.dispatch('login', credentials);
            }
        },
        mounted() {
            this.$nextTick(() => {
                this.$refs.username.focus();
            })
        }
    }
</script>
